import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const ServiceProcessCard = ({ phase, stepNumber }) => (
  <Card className="bg-white">
    <CardContent className="p-8 space-y-6">
      <div className="flex items-center space-x-3">
        <div className="bg-blue-600 text-white rounded-full w-10 h-10 flex items-center justify-center font-bold">
          {stepNumber}
        </div>
        <h3 className="text-xl font-bold text-gray-900">{phase.title}</h3>
      </div>
      <ul className="space-y-3">
        {phase.items.map((item) => (
          <li key={item} className="flex items-start space-x-3">
            <ArrowRight className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
            <span className="text-gray-700">{item}</span>
          </li>
        ))}
      </ul>
    </CardContent>
  </Card>
);

export default ServiceProcessCard;
